const deCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "Name your file...",
    description: "Placeholder for file name input",
  },
};

export default deCreateFile;
